import { useState, useEffect } from 'react';
/* datas */
import { HostBackend } from '../../../../Routes/HostBackend.js';
import { GetStatusChooser } from '../Functions/GetStatusChooser.js';
/* document */
import { Select } from '../../Form/Inputs/Select.js';
import { Checkbox } from '../../Form/Inputs/Checkbox.js';
import { Date } from '../../Form/Inputs/Date.js';
import { Text } from '../../Form/Inputs/Text.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Attraction = (props) => {
    const { el } = props;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const statusChooser = GetStatusChooser();
    const [choosers, setChoosers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasChoosers = await fetch(`${backend}/admin/choosers/attraction`, {
                method: 'GET', headers: { 'Authorization': token, 'Content-Type': 'application/json' }
            });
            const choosers = await datasChoosers.json();
            setChoosers(choosers);
        };
        fetchData();
    }, [backend, token]);
    return (
        <>
            <Select name="status" choosers={statusChooser} value={el ? el.status : ''} />
            <Select name="id_park" choosers={choosers.parks} value={el ? el.id_park : ''} />
            <Select name="id_univ" choosers={choosers.univers} value={el ? el.id_univ : ''} />
            <Text name="name" value={el ? el.name : ''} />
            <Text name="slug" value={el ? el.slug : ''} />
            <Text name="route" value={el ? el.route : ''} class={'active-check'} />
            <Text name="author" value={el ? el.author : ''} />
            <Date name="created" value={el ? el.created : ''} />
            <Date name="closed" value={el ? el.closed : ''} />
            <Select name="id_category" choosers={choosers.category} value={el ? el.id_category : ''} />
            <Select name="id_origin" choosers={choosers.origin} value={el ? el.id_origin : ''} />
            <Select name="id_family" choosers={choosers.family} value={el ? el.id_family : ''} />
            <Select name="id_description" choosers={choosers.describe} value={el ? el.id_description : ''} />
            <Select name="id_public" choosers={choosers.public} value={el ? el.id_public : ''} />
            <Select name="id_photopass" choosers={choosers.photopass} value={el ? el.id_photopass : ''} />
            <Select name="id_pmr" choosers={choosers.pmr} value={el ? el.id_pmr : ''} />
            <Select name="id_singlerider" choosers={choosers.singlerider} value={el ? el.id_singlerider : ''} />
            <Checkbox name="premieraccess" choosers={choosers.premieraccess} value={el ? el.premieraccess : ''} />
            <Text name="duration" value={el ? el.duration : ''} />
            <Text name="height" value={el ? el.height : ''} />
            <Text name="width" value={el ? el.width : ''} />
            <Text name="speed" value={el ? el.speed : ''} />
            <Text name="ability" value={el ? el.ability : ''} />
            <Select name="id_evacuation" choosers={choosers.evacuation} value={el ? el.id_evacuation : ''} />
            <Select name="id_height" choosers={choosers.height} value={el ? el.id_height : ''} />
            <Select name="id_sensory" choosers={choosers.sensory} value={el ? el.id_sensory : ''} />
            <Checkbox name="handicaps" choosers={choosers.handicap} value={el ? el.handicaps : ''} />
            <Checkbox name="interests" choosers={choosers.interest} value={el ? el.interests : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}
